const errorExcludedMessages = ["An error occurred"];

export const formErrorMessage = (error, defaultMessage) => {
  if (error?.message && !errorExcludedMessages.includes(error?.message)) {
    return error.message;
  }

  if (error?.description) {
    const regex = /(?:\w+):\s*([^:]+?)(?=\s*\w+:|$)/;
    const match = error.description.match(regex);

    return match ? match[1].trim() : error.description.trim();
  }

  return defaultMessage;
};
